/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2022-12-12 10:03:27
 * @FilePath: \sns-user-frontend\src\service\ugc.js
 * @Description: UGC
 */
import { get, post } from './http'

const msgPath = 'msg/frontend/'
const MSG = {
  // 系统消息
  getSystemList: (params) => {
    return get(`${msgPath}system/index/list`, params)
  },
  // 互动消息
  getInteractList: (params) => {
    return get(`${msgPath}index/list`, params)
  },
  getMessageNum: () => {
    return get(`${msgPath}index/num`)
  }
}


export default MSG